<template>
  <b-container fluid>
    <b-col class="col-lg-10-" offset="1">
      <b-row>
        <b-col class="col-lg-12" style="margin-top: 15px">
          <h2 class="text-left">{{title}}</h2>
          <b-alert :show="loading" variant="info">Bezig met laden...</b-alert>
          <b-alert v-model="errorMessageVisible" variant="danger" dismissible>{{errorMessage}}</b-alert>
        </b-col>
      </b-row>
      <b-col class="col-lg-10 border" style="padding-top: 10px">
        <b-row>
          <b-col class="col-lg-12">
            <b-form-group label=""
                          label-for="filter-input"
                          label-cols="0">
              <b-input-group>
                <b-form-input id="filter-input"
                              v-model="filter"
                              type="search"
                              placeholder="Type om te zoeken"></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''" size="sm">Wissen</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-lg-12">
            <b-table striped hover outlined
                     id="loggingTable"
                     :items="loggings"
                     :fields="fields"
                     :filter="filter"
                     :filter-included-fields="filterOn"
                     :per-page="perPage"
                     :current-page="currentPage"
                     @filtered="onFiltered"
                     sort-icon-left
                     sort-by="logged" sortDesc>
              <template #cell(details)="row">
                <b-link v-bind:to="{ name: 'loggingdetails', params: { id: row.item.id } }">Details</b-link>
              </template>
              <template #cell(logged)="row">
                <span>{{ new Date(row.item.logged).toLocaleString('en-GB')}}</span>
              </template>
              <template #cell(logger)="row">
                <span>{{ row.item.logger.replace('DV.Ideavelop.Middleware.', '')}}</span>
              </template>
              <template #cell(message)="row">
                <span>{{ row.item.message.substring(0, 50)}}</span>
              </template>
            </b-table>
            <b-pagination v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          aria-controls="loggingTable"></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-col>
  </b-container>
</template>
<script>
  import ErrorHandlerMixin from '@/mixins/ErrorHandlerMixin'

  export default {
    name: 'LoggingOverview',
    mixins: [ErrorHandlerMixin],
    data() {
      return {
        title: 'Overzicht Logging',
        loading: false,
        loggings: [],
        fields: [
          {
            key: 'logged',
            label: 'Datum/Tijd',
            sortable: true,
          },
          {
            key: 'level',
            label: 'Level',
            sortable: true,
          },
          {
            key: 'logger',
            label: 'Bron',
            sortable: true,
          },
          {
            key: 'message',
            label: 'Bericht',
            sortable: false,
          },
          {
            key: 'details',
            label: 'Details'
          }
        ],
        totalRows: 1,
        perPage: 10,
        currentPage: 1,
        filter: null,
        filterOn: ['loggingDateTime', 'level', 'source', 'messageShort']
      }
    },
    created: function () {
      this.loading = true;
      this.$api.get('Logging/list')
        .then((response) => {
          this.loggings = response.data
          this.totalRows = this.loggings.length
        })
        .catch((error) => {
          this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de logregels.')
        })
        .finally(() => {
          this.loading = false
        })
      this
    },
    computed: {
    },
    methods: {
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
    }
  }
</script>
